import api from './axios';

export type TableZone = 'salon' | 'patio' | 'otros';

// Etiquetas para la UI. La key debe coincidir con el enum del backend.
export const TABLE_ZONES: { key: TableZone; label: string }[] = [
  { key: 'salon', label: 'Salon' },
  { key: 'patio', label: 'Patio' },
  { key: 'otros', label: 'Otros' },
];

export const tablesApi = {
  getAll: (zone?: TableZone) => api.get('/tables', { params: zone ? { zone } : undefined }),
  getById: (id: number) => api.get(`/tables/${id}`),
  create: (data: any) => api.post('/tables', data),
  update: (id: number, data: any) => api.put(`/tables/${id}`, data),
  updateStatus: (id: number, status: string) => api.patch(`/tables/${id}/status`, { status }),
  delete: (id: number) => api.delete(`/tables/${id}`),
};
